import { Box } from '@mui/material'
import { codeBlockPreSx, codeBlockRootSx } from './codeBlockViewSx.js'
import { CodeBlockCopyBar } from './CodeBlockCopyBar.jsx'
import { useCodeBlockCopy } from './useCodeBlockCopy.js'

export default function CodeBlockView({ code, language }) {
  const { copied, handleCopy } = useCodeBlockCopy(code)

  return (
    <Box sx={codeBlockRootSx}>
      <CodeBlockCopyBar language={language} copied={copied} onCopy={handleCopy} />
      <Box sx={{ p: '10px', pt: language ? '4px' : '10px', overflowX: 'auto' }}>
        <Box component="pre" sx={codeBlockPreSx}>
          <code>{code}</code>
        </Box>
      </Box>
    </Box>
  )
}
